var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1725 23.2258C34.9744 22.788 34.5391 22.5092 34.0598 22.5092H29.1685V6.61247C29.1685 5.93747 28.6206 5.38965 27.9456 5.38965H23.0543C22.3793 5.38965 21.8315 5.93747 21.8315 6.61247V22.5092H16.9402C16.4609 22.5092 16.0255 22.7905 15.8274 23.2258C15.6269 23.6636 15.7051 24.1747 16.0206 24.5367L24.5804 34.3193C24.8128 34.5858 25.1478 34.7375 25.5 34.7375C25.8522 34.7375 26.1872 34.5834 26.4195 34.3193L34.9793 24.5367C35.2973 24.1771 35.3706 23.6636 35.1725 23.2258Z",
    fill: "#34A853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9511 32.2918V39.6288H12.0489V32.2918H7.15759V42.0744C7.15759 43.4269 8.25324 44.5201 9.60325 44.5201H41.3967C42.7492 44.5201 43.8424 43.4269 43.8424 42.0744V32.2918H38.9511Z",
    fill: "#34A853"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.12ba13865c9bdd47ec6959fb5c8048da.svg";
export { ForwardRef as ReactComponent };